import { AppMembershipRoleEnum } from 'src/graphql/schema';

export const roleOptions = [
  { label: 'Manager', value: AppMembershipRoleEnum.Manager },
  { label: 'Viewer', value: AppMembershipRoleEnum.Viewer },
];

export const roleOptionsDict = roleOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {},
) as Record<AppMembershipRoleEnum, string>;
